// ExpandableCell.tsx
import React, { useState } from 'react';
import { Link, SpaceBetween } from '@amzn/awsui-components-console';
import { useTranslation } from 'src/i18n/shim/useTranslation';

interface ExpandableCellProps {
  items: string[] | undefined;
  maxVisible?: number;
}

/**
 * Comma-joined rather than via `joinList`: the items are CX IDs, and this list is
 * truncated with a "show more" link, so a conjunction would read as if the list
 * had ended at the cut-off.
 */
const ExpandableCell: React.FC<ExpandableCellProps> = ({
  items,
  maxVisible = 3,
}) => {
  const { t } = useTranslation();
  const [expanded, setExpanded] = useState(false);

  if (!items || items.length === 0) return <>—</>;
  if (items.length <= maxVisible) return <>{items.join(', ')}</>;

  const displayed = expanded ? items : items.slice(0, maxVisible);
  const remaining = items.length - maxVisible;

  return (
    <SpaceBetween size="xxs" direction="horizontal">
      <span>{displayed.join(', ')}</span>
      <Link
        onFollow={(e) => {
          e.preventDefault();
          setExpanded(!expanded);
        }}
        variant="info"
      >
        {expanded
          ? t('cell-show-less')
          : t('cell-show-more-count', { count: remaining })}
      </Link>
    </SpaceBetween>
  );
};

export default ExpandableCell;
